// import React, { useRef, useState, useEffect } from "react";
// import "./DppScheduling.css";
// import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
// import InputComponent from "../TestScheduling/Input-testscheduling";
// import { FULL_API_BASE_URL } from "../../../Config/Config";
// import introgativeImgBlue from "../../../Assets/Images/CommanImages/IntrogativeBlue.png";
// import TextEditor from "./TextEditor";
// import InputComponent2 from "./InputComponent";
// import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
// import SucessImg from "../../../Assets/Images/CommanImages/success.png";
// import MultiSelectSearchDropdown from "./MultiDropdownClassic";
// import { useLocation } from "react-router-dom";
// import { POST } from "../../../Api/HttpsMethods";
// import { GET } from "../../../Api/HttpsMethods";
// import EndPoints from "../../../Api/EndPoints";
// import { useNavigate } from "react-router-dom";
// import Colors from "../../../Constants/Colors";
// import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";

// const DppScheduling = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const location = useLocation();
//   const dppData = location.state;
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (dataClient) {
//       const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
//       const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//       const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
//       sessionStorage.setItem("user_name", userName);
//       sessionStorage.setItem("clientBranchId", clientBranchId);
//       sessionStorage.setItem("clientId", clientId);
//     }
//   }, [dataClient]);

//   const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || sessionStorage.getItem("user_name") || "";
//   const clientBranchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || sessionStorage.getItem("clientBranchId") || null;
//   const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || sessionStorage.getItem("clientId") || null;
//   const accessToken = localStorage.getItem("other");

//   const [selectedQuestionPaperSubjects, setSelectedQuestionPaperSubjects] = useState("");
//   const [selectedChapterId, setSelectedChapterId] = useState([]);
//   const [selectedChapterName, setSelectedChapterName] = useState("");
//   const [selectedTopicId, setSelectedTopicId] = useState([]);
//   const [selectedTopicName, setSelectedTopicName] = useState("");
//   const [instructionsHtml, setInstructionsHtml] = useState("");
//   const [selectedQuestionPaperId, setSelectedQuestionPaperId] = useState("");
//   const [selectedQuestionPaperName, setSelectedQuestionPaperName] = useState("");
//   const [selectedQuestionPaperDescription, setSelectedQuestionPaperDescription] = useState("");
//   const [selectedQuestionPaperCreatedBy, setSelectedQuestionPaperCreatedBy] = useState("");
//   const [testTemplates, setTestTemplates] = useState([]);
//   const [testStartDate, setTestStartDate] = useState(null);
//   const [testEndDate, setTestEndDate] = useState(null);
//   const [courses, setCourses] = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [chapters, setChapters] = useState([]);
//   const [classes, setClasses] = useState([]);
//   const [topics, setTopics] = useState([]);
//   const [questionPapers, setQuestionPapers] = useState([]);
//   const [dppName, setDppName] = useState("");
//   const [DppDescription, setDppDescription] = useState("");
//   const [CordinatorName, setCordinatorName] = useState("");
//   const [batches, setBatches] = useState([]);
//   const [selectedCourseId, setSelectedCourseId] = useState("");
//   const [selectedCourseName, setSelectedCourseName] = useState("");
//   const [selectedBatchId, setSelectedBatchId] = useState("");
//   const [selectedBatchName, setSelectedBatchName] = useState("");
//   const [selectedSubjectId, setSelectedSubjectId] = useState("");
//   const [selectedSubjectName, setSelectedSubjectName] = useState("");
//   const [selectedClassId, setSelectedClassId] = useState("");
//   const [selectedClassName, setSelectedClassName] = useState("");
//   const [selectedStudentGroup, setSelectedStudentGroup] = useState([]);
//   const [studentGroupsOptions, setStudentGroupsOptions] = useState([]);
//   const [allStudentGroups, setAllStudentGroups] = useState([]);
//   const [studentGroupsError, setStudentGroupsError] = useState(null);
//   const [serverCurrentTime, setServerCurrentTime] = useState(null);
//   const [isOpenSubject, setIsOpenSubject] = useState(true);

//   // ── Fetch server current time ─────────────────────────────────────────────
//   useEffect(() => {
//     const fetchServerTime = async () => {
//       try {
//         const token = localStorage.getItem("other");
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-current-datetime/`,
//           { headers: { accept: "application/json", Authorization: `Bearer ${token}` } }
//         );
//         const data = await response.json();
//         if (data?.status === 200 && data?.data) {
//           const { current_date, current_time } = data.data;
//           setServerCurrentTime(`${current_date}T${current_time}`);
//         }
//       } catch (error) {
//         console.error("Error fetching server time:", error);
//         setServerCurrentTime(new Date().toISOString());
//       }
//     };
//     fetchServerTime();
//   }, []);

//   // ── getCurrentDateTime: server time + 15 min buffer ──────────────────────
//   const getCurrentDateTime = () => {
//     const base = serverCurrentTime ? new Date(serverCurrentTime) : new Date();
//     base.setMinutes(base.getMinutes() + 15);
//     const year  = base.getFullYear();
//     const month = String(base.getMonth() + 1).padStart(2, "0");
//     const day   = String(base.getDate()).padStart(2, "0");
//     const hours = String(base.getHours()).padStart(2, "0");
//     const mins  = String(base.getMinutes()).padStart(2, "0");
//     return `${year}-${month}-${day}T${hours}:${mins}`;
//   };

//   // ── getMinEndDateTime: start + 24 hours ──────────────────────────────────
//   const getMinEndDateTime = (startDateTime) => {
//     if (!startDateTime) return getCurrentDateTime();
//     const startDate = new Date(startDateTime);
//     const minEndDate = new Date(startDate.getTime() + 24 * 60 * 60 * 1000);
//     const year  = minEndDate.getFullYear();
//     const month = String(minEndDate.getMonth() + 1).padStart(2, "0");
//     const day   = String(minEndDate.getDate()).padStart(2, "0");
//     const hours = String(minEndDate.getHours()).padStart(2, "0");
//     const mins  = String(minEndDate.getMinutes()).padStart(2, "0");
//     return `${year}-${month}-${day}T${hours}:${mins}`;
//   };

//   useEffect(() => {
//     if (!userName || !clientBranchId) return;
//     const fetchTestTemplates = async () => {
//       try {
//         const token = localStorage.getItem("other");
//         const response = await fetch(
//           `${FULL_API_BASE_URL}/get-dpp-instructions-template-list/?username=${userName}&branch_id=${clientBranchId}`,
//           { headers: { accept: "application/json", Authorization: `Bearer ${accessToken}` } }
//         );
//         if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
//         const data = await response.json();
//         setTestTemplates(data);
//       } catch (error) {
//         console.error("Error fetching test templates:", error);
//         if (setMessageBox) {
//           setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><div className="loader-tc"></div><span>Error fetching test templates: {error.message}</span></div></div>);
//           setIsMessageBoxVisible(true);
//           setActiveImg(ErrorImg);
//         }
//       }
//     };
//     fetchTestTemplates();
//   }, [userName, clientBranchId]);

//   useEffect(() => {
//     const fetchCourses = async () => {
//       try {
//         const response = await fetch(`${FULL_API_BASE_URL}/get-courses/`, { headers: { accept: "application/json" } });
//         const data = await response.json();
//         setCourses(data);
//       } catch (error) {
//         console.error("Error fetching courses:", error);
//       }
//     };
//     fetchCourses();
//   }, []);

//   useEffect(() => {
//     const fetchBatches = async () => {
//       if (!selectedCourseId) return;
//       const url = `${EndPoints.GetBatchByCourse}?course_id=${selectedCourseId}`;
//       const data = await GET.noToken(url, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
//       if (Array.isArray(data?.[0])) {
//         setBatches(selectedClassId ? data[0].filter((batch) => batch.class_id === selectedClassId) : data[0]);
//       } else setBatches([]);
//     };
//     fetchBatches();
//   }, [selectedCourseId, selectedClassId]);

//   useEffect(() => {
//     const fetchSubjects = async () => {
//       if (!selectedCourseId) return;
//       const url = `${EndPoints.GetSubjectsByCourse}?course_id=${selectedCourseId}`;
//       const data = await GET.noToken(url, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
//       if (data) setSubjects(data);
//     };
//     fetchSubjects();
//   }, [selectedCourseId]);

//   useEffect(() => {
//     const fetchChapters = async () => {
//       if (!selectedSubjectId) return;
//       const url = `${EndPoints.GetChaptersBySubject}?subject_id=${selectedSubjectId}`;
//       const data = await GET.noToken(url, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
//       if (data) setChapters(data);
//     };
//     fetchChapters();
//   }, [selectedSubjectId]);

//   useEffect(() => {
//     const fetchTopics = async () => {
//       if (!selectedChapterId || !Array.isArray(selectedChapterId) || selectedChapterId.length === 0) { setTopics([]); return; }
//       const data = await POST.withToken(EndPoints.TopicsByChapterList, selectedChapterId, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
//       if (data && data.status_code === 200 && Array.isArray(data.data)) setTopics(data.data);
//       else setTopics([]);
//     };
//     fetchTopics();
//   }, [selectedChapterId]);

//   useEffect(() => {
//     const fetchClasses = async () => {
//       const data = await GET.noToken(EndPoints.GetClasses, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
//       if (data) setClasses(data);
//     };
//     fetchClasses();
//   }, []);

//   useEffect(() => {
//     const fetchQuestionPapers = async () => {
//       if (!clientBranchId || !selectedClassId || !selectedSubjectId) return;
//       let baseUrl = `${EndPoints.DPP_QUESTION_PAPER_V2}?branch_id=${clientBranchId}&class_id=${selectedClassId}&subject_id=${selectedSubjectId}`;
//       if (selectedBatchId) baseUrl += `&batch_id=${selectedBatchId}`;
//       if (selectedStudentGroup && selectedStudentGroup.length > 0) {
//         (Array.isArray(selectedStudentGroup) ? selectedStudentGroup : [selectedStudentGroup]).forEach(id => { baseUrl += `&student_group_ids=${id}`; });
//       }
//       if (Array.isArray(selectedChapterId) && selectedChapterId.length > 0) selectedChapterId.forEach((id) => { baseUrl += `&chapter_id=${id}`; });
//       if (Array.isArray(selectedTopicId) && selectedTopicId.length > 0) selectedTopicId.forEach((id) => { baseUrl += `&topic_id=${id}`; });
//       try {
//         const response = await fetch(baseUrl, { method: "GET", headers: { accept: "application/json", Authorization: `Bearer ${accessToken}` } });
//         const result = await response.json();
//         if (result?.status === 200) setQuestionPapers(result.data);
//         else setQuestionPapers([]);
//       } catch (error) {
//         console.error("Error fetching question papers:", error);
//         setQuestionPapers([]);
//       }
//     };
//     fetchQuestionPapers();
//   }, [selectedChapterId, selectedTopicId, selectedSubjectId, selectedClassId, clientBranchId, selectedBatchId, selectedStudentGroup]);

//   // ── handleSave — all date validation happens here ─────────────────────────
//   const handleSave = async () => {
//     // ── Validate start date ───────────────────────────────────────────────────
//     const minAllowed = getCurrentDateTime(); // server time + 15 min
//     if (!testStartDate) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><div className="loader-tc"></div><span>Please select a DPP Window Start date.</span></div></div>);
//       setActiveImg(ErrorImg); setIsMessageBoxVisible(true); return;
//     }
//     if (testStartDate < minAllowed) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><div className="loader-tc"></div><span>DPP window start must be at least 15 minutes from current time. Please correct the start time before saving.</span></div></div>);
//       setActiveImg(ErrorImg); setIsMessageBoxVisible(true); return;
//     }

//     // ── Validate end date ─────────────────────────────────────────────────────
//     if (!testEndDate) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><div className="loader-tc"></div><span>Please select a DPP Window End date.</span></div></div>);
//       setActiveImg(ErrorImg); setIsMessageBoxVisible(true); return;
//     }
//     if (testEndDate <= testStartDate) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><div className="loader-tc"></div><span>DPP window end must be after the DPP window start.</span></div></div>);
//       setActiveImg(ErrorImg); setIsMessageBoxVisible(true); return;
//     }
//     if (testEndDate < getMinEndDateTime(testStartDate)) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><div className="loader-tc"></div><span>DPP window end must be at least 24 hours after the start time.</span></div></div>);
//       setActiveImg(ErrorImg); setIsMessageBoxVisible(true); return;
//     }

//     // ── Validate other required fields ────────────────────────────────────────
//     if (!dppName.trim()) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><div className="loader-tc"></div><span>Please enter a DPP Name.</span></div></div>);
//       setIsMessageBoxVisible(true); setActiveImg(ErrorImg); return;
//     }

//     const studentGroupIds = Array.isArray(selectedStudentGroup) ? selectedStudentGroup : (selectedStudentGroup ? [selectedStudentGroup] : []);

//     const body = {
//       request: {
//         ques_paper_id: selectedQuestionPaperId,
//         dpp_name: dppName,
//         dpp_desc: DppDescription,
//         batch_id: selectedBatchId || 0,
//         student_group_ids: studentGroupIds,
//         dpp_window_start: testStartDate,
//         dpp_window_end: testEndDate,
//         client_id: clientId,
//         client_branch_id: clientBranchId,
//         created_by: userName,
//         instructions_html: instructionsHtml,
//         subject_id: selectedSubjectId || 0,
//         chapter_names: selectedChapterName,
//         topic_names: selectedTopicName,
//       },
//       payload: {
//         user_name: userName,
//         client_branch_id: clientBranchId ? Number(clientBranchId) : 0,
//         screen_event_id: 72,
//         screen_id: 77,
//         student_id: null,
//         batch_id: selectedBatchId ? [selectedBatchId] : null,
//         subject_id: selectedSubjectId ? [selectedSubjectId] : null,
//         class_id: selectedClassId ? [selectedClassId] : null,
//         course_id: selectedCourseId ? [selectedCourseId] : null,
//         session_id: null,
//         student_group_id: studentGroupIds.length ? studentGroupIds : null,
//       },
//     };

//     try {
//       const token = localStorage.getItem("other");
//       const response = await fetch(EndPoints.CREATE_DPP_SCHEDULE_NOTIFICATION, {
//         method: "POST",
//         headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//         body: JSON.stringify(body),
//       });
//       if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//       const data = await response.json();
//       if (data && data.status === 200) {
//         setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><div className="loader-tc"></div><span>{data.message || "DPP schedule created successfully!"}</span></div></div>);
//         setIsMessageBoxVisible(true);
//         setActiveImg(SucessImg);
//         setTimeout(() => { navigate(-1); }, 1000);
//       } else {
//         setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><div className="loader-tc"></div><span>{"Failed to create DPP Schedule: " + (data?.message || data?.detail || "Unknown error")}</span></div></div>);
//         setIsMessageBoxVisible(true);
//         setActiveImg(ErrorImg);
//       }
//     } catch (error) {
//       setMessageBox(<div className="Container-messageBOX"><div className="messagebox-insider1"><div className="loader-tc"></div><span>Error creating DPP schedule: {error.message}</span></div></div>);
//       setIsMessageBoxVisible(true);
//       setActiveImg(ErrorImg);
//     }
//   };

//   useEffect(() => {
//     if (!selectedQuestionPaperId) { setSelectedQuestionPaperSubjects(""); return; }
//     const qp = questionPapers.find((q) => q.ques_paper_id === selectedQuestionPaperId);
//     setSelectedQuestionPaperSubjects(qp?.subject_name || "");
//   }, [selectedQuestionPaperId, questionPapers]);

//   // Cascading clear logic
//   useEffect(() => { setSelectedBatchId(""); setSelectedBatchName(""); }, [selectedClassId]);
//   useEffect(() => { setSelectedSubjectId(""); setSelectedSubjectName(""); }, [selectedBatchId]);
//   useEffect(() => { setSelectedChapterId([]); setSelectedChapterName(""); }, [selectedSubjectId]);
//   useEffect(() => { setSelectedTopicId([]); setSelectedTopicName(""); }, [selectedChapterId]);
//   useEffect(() => { setSelectedQuestionPaperId(""); setSelectedQuestionPaperName(""); }, [selectedCourseId, selectedClassId, selectedBatchId, selectedSubjectId, selectedChapterId, selectedTopicId]);
//   useEffect(() => {
//     if (!selectedQuestionPaperId) {
//       setSelectedQuestionPaperDescription(""); setSelectedQuestionPaperCreatedBy("");
//       setSelectedQuestionPaperSubjects(""); setCordinatorName("");
//     }
//   }, [selectedQuestionPaperId]);

//   useEffect(() => {
//     const fetchStudentGroups = async () => {
//       if (!clientBranchId) return;
//       try {
//         setStudentGroupsError(null);
//         const url = `${FULL_API_BASE_URL}/get-shared-student-groups?client_branch_id=${clientBranchId}`;
//         const resp = await fetch(url, { headers: { accept: "application/json", Authorization: `Bearer ${accessToken}` } });
//         if (resp.status === 401 || resp.status === 403) {
//           setStudentGroupsError("Not authenticated. Please login.");
//           setStudentGroupsOptions([]); setAllStudentGroups([]); return;
//         }
//         const json = await resp.json();
//         if (json && (json.status === "200" || json.status === 200) && Array.isArray(json.data)) {
//           const options = json.data.map((group) => ({ id: group.student_group_id, label: group.student_group_name, session_id: group.session_id || "", course_id: group.course_id || "" }));
//           setStudentGroupsOptions(options); setAllStudentGroups(options);
//         } else { setStudentGroupsOptions([]); setAllStudentGroups([]); }
//       } catch (err) {
//         setStudentGroupsError(err.message || "Error loading student groups");
//         setStudentGroupsOptions([]); setAllStudentGroups([]);
//       }
//     };
//     fetchStudentGroups();
//   }, [clientBranchId, accessToken]);

//   useEffect(() => { setSelectedStudentGroup([]); }, [selectedCourseId]);

//   const getFilteredStudentGroups = () => {
//     if (!selectedCourseId) return studentGroupsOptions;
//     return studentGroupsOptions.filter((g) => g.course_id === selectedCourseId);
//   };

//   const searchStudentGroups = (searchKey) => {
//     let filtered = allStudentGroups;
//     if (selectedCourseId) filtered = filtered.filter((g) => g.course_id === selectedCourseId);
//     if (searchKey && searchKey.trim() !== "") filtered = filtered.filter((g) => g.label.toLowerCase().includes(searchKey.toLowerCase()));
//     setStudentGroupsOptions(filtered);
//   };

//   const toggleAccordionSubjects = () => { setIsOpenSubject(!isOpenSubject); };

//   return (
//     <div className="create-role-container">
//       <div className="create-role-container-ques-paper-del">
//         <span className="create-role-heading">DPP Scheduling</span>
//         <div className="cr-header-btn-container">
//           <button className="cr-cancel-btn" onClick={() => navigate(-1)}>CANCEL</button>
//           <button className="cr-create-btn" onClick={handleSave}>SAVE</button>
//         </div>
//       </div>
//       <div className="ques-paper-del">
//         <div className="personal-header">
//           <div className="header"><label>QUESTION PAPER DETAIL</label></div>
//         </div>
//         <div className="accordion-content">
//           <div className="select-assign-test-container-ques-pap-del">
//             <div className="grid-container-ques-paper-del">
//               <div>
//                 <DropDown
//                   label="Select Course" style={{ width: "100%" }}
//                   setSelected={(selectedId) => { setSelectedCourseId(selectedId); setSelectedCourseName(selectedId.label); }}
//                   options={courses.map((course) => ({ label: course.course_name, id: course.course_id }))}
//                   isRequired={true}
//                 />
//               </div>
//               <div>
//                 <DropDown
//                   key={`class-${selectedCourseId}`} label="Select Class" style={{ width: "100%" }} value={selectedClassId}
//                   setSelected={(selectedClassIdFromDD) => {
//                     const classOption = Array.isArray(classes) ? classes.find((cls) => cls.class_id === selectedClassIdFromDD) : undefined;
//                     if (classOption) { setSelectedClassId(classOption.class_id); setSelectedClassName(classOption.class_name); }
//                     else { setSelectedClassId(""); setSelectedClassName(""); }
//                   }}
//                   options={classes.map((cls) => ({ label: cls.class_name, id: cls.class_id }))}
//                   isRequired={true}
//                 />
//               </div>
//               <div>
//                 <DropDown
//                   key={`batch-${selectedClassId}`} label="Batch Name" style={{ width: "100%" }} value={selectedBatchId}
//                   setSelected={(selectedBatchIdFromDD) => {
//                     const batchOption = Array.isArray(batches) ? batches.find((batch) => batch.batch_id === selectedBatchIdFromDD) : undefined;
//                     if (batchOption) { setSelectedBatchId(batchOption.batch_id); setSelectedBatchName(batchOption.batch_name); }
//                     else { setSelectedBatchId(""); setSelectedBatchName(""); }
//                   }}
//                   options={batches.map((batch) => ({ label: batch.batch_name, id: batch.batch_id }))}
//                   isRequired={false}
//                 />
//               </div>
//               <div>
//                 <MultiSelectSearchDropdown
//                   label="Student Group" width="100%" selected={selectedStudentGroup} setSelected={setSelectedStudentGroup}
//                   options={getFilteredStudentGroups().map((g) => ({ label: g.label, id: g.id }))}
//                   isRequired={false} placeholder="Select Student Group..." singleSelect={false} onSearchInputChange={searchStudentGroups}
//                 />
//                 {studentGroupsError && <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>{studentGroupsError}</div>}
//               </div>
//               <div>
//                 <DropDown
//                   key={`subject-${selectedBatchId}`} label="Select Subject" style={{ width: "100%" }} value={selectedSubjectId}
//                   setSelected={(selectedSubjectIdFromDD) => {
//                     const subjectOption = Array.isArray(subjects) ? subjects.find((subject) => subject.subject_id === selectedSubjectIdFromDD) : undefined;
//                     if (subjectOption) { setSelectedSubjectId(subjectOption.subject_id); setSelectedSubjectName(subjectOption.subject_name); }
//                     else { setSelectedSubjectId(""); setSelectedSubjectName(""); }
//                   }}
//                   options={subjects.map((subject) => ({ label: subject.subject_name, id: subject.subject_id }))}
//                 />
//               </div>
//               <div>
//                 <MultiSelectSearchDropdown
//                   label="Select Chapter (Optional)" width="100%" selected={selectedChapterId}
//                   setSelected={(selectedIds) => {
//                     setSelectedChapterId(selectedIds);
//                     if (Array.isArray(selectedIds) && selectedIds.length > 0)
//                       setSelectedChapterName(chapters.filter((c) => selectedIds.includes(c.chapter_id)).map((c) => c.chapter_name).join(", "));
//                     else setSelectedChapterName("");
//                   }}
//                   options={chapters.map((chapter) => ({ label: chapter.chapter_name, id: chapter.chapter_id }))}
//                   isRequired={false}
//                 />
//               </div>
//               <div>
//                 <MultiSelectSearchDropdown
//                   label="Select Topic (Optional)" width="100%" selected={selectedTopicId}
//                   setSelected={(selectedIds) => {
//                     setSelectedTopicId(selectedIds);
//                     if (Array.isArray(selectedIds) && selectedIds.length > 0)
//                       setSelectedTopicName((Array.isArray(topics) ? topics.filter((t) => selectedIds.includes(t.topic_id)) : []).map((t) => t.topic_name).join(", "));
//                     else setSelectedTopicName("");
//                   }}
//                   options={Array.isArray(topics) ? topics.map((topic) => ({ label: topic.topic_name, id: topic.topic_id })) : []}
//                   isRequired={false}
//                 />
//               </div>
//               <div>
//                 <DropDown
//                   label="Question Paper Name" style={{ width: "100%" }}
//                   setSelected={(selectedQPId) => {
//                     const qpOption = Array.isArray(questionPapers) ? questionPapers.find((qp) => qp.ques_paper_id === selectedQPId) : undefined;
//                     if (qpOption) {
//                       setSelectedQuestionPaperId(qpOption.ques_paper_id);
//                       setSelectedQuestionPaperName(qpOption.ques_paper_name);
//                       setSelectedQuestionPaperDescription(qpOption.description);
//                       setSelectedQuestionPaperCreatedBy(qpOption.created_by);
//                       setSelectedQuestionPaperSubjects(qpOption.subject_name || "");
//                     } else {
//                       setSelectedQuestionPaperId(""); setSelectedQuestionPaperName("");
//                       setSelectedQuestionPaperDescription(""); setSelectedQuestionPaperCreatedBy("");
//                       setSelectedQuestionPaperSubjects("");
//                     }
//                   }}
//                   options={questionPapers.map((qp) => ({ label: qp.ques_paper_name, id: qp.ques_paper_id }))}
//                   isRequired={true} minheight="250px" Height="auto" OverFlow="auto"
//                 />
//               </div>
//               <div>
//                 <InputComponent label="Question Paper Subjects" style={{ width: "100%" }} value={selectedQuestionPaperSubjects} isRequired={false} disable={true} />
//               </div>
//               <div>
//                 <InputComponent label="Question Paper Created By" style={{ width: "100%" }} value={selectedQuestionPaperCreatedBy} isRequired={false} disable={true} />
//               </div>
//               <div style={{ gridColumn: "2 / 4" }}>
//                 <InputComponent label="Question Paper Description" style={{ width: "100%" }} value={selectedQuestionPaperDescription} isRequired={false} disable={true} />
//               </div>
//               <div>
//                 <FormInputs label="DPP Name" value={dppName} onChange={(e) => setDppName(e.target.value)} placeholder="Enter DPP name" style={{ width: "100%" }} required />
//               </div>
//               <div style={{ gridColumn: "2 / 4" }}>
//                 <FormInputs label="Description" value={DppDescription} onChange={(e) => setDppDescription(e.target.value)} placeholder="Enter Description" style={{ width: "100%" }} required />
//               </div>
//               <div>
//                 <FormInputs label="Batch Coordinator Name" style={{ width: "100%" }} value={CordinatorName} isRequired={false} disable={true} />
//               </div>

//               {/* ── DPP Window Start — free input, all validation on SAVE ─── */}
//               <div>
//                 <FormInputs
//                   label="DPP Window Start"
//                   style={{ width: "100%" }}
//                   value={testStartDate || ""}
//                   isRequired={false}
//                   disable={false}
//                   type="datetime-local"
//                   min={getCurrentDateTime()}
//                   onChange={(e) => {
//                     const newStartDate = e.target.value;
//                     setTestStartDate(newStartDate);
//                     // Auto-fill end to start + 24h (UX convenience, not validation)
//                     if (newStartDate) {
//                       setTestEndDate(getMinEndDateTime(newStartDate));
//                     }
//                   }}
//                   required
//                 />
//               </div>

//               {/* ── DPP Window End — free input, all validation on SAVE ───── */}
//               <div>
//                 <FormInputs
//                   label="DPP Window End"
//                   style={{ width: "100%" }}
//                   value={testEndDate || ""}
//                   isRequired={false}
//                   disable={false}
//                   type="datetime-local"
//                   min={testStartDate ? getMinEndDateTime(testStartDate) : getCurrentDateTime()}
//                   onChange={(e) => {
//                     setTestEndDate(e.target.value);
//                   }}
//                   required
//                 />
//               </div>
//             </div>
//           </div>
//           <div style={{ padding: "0px 60px 20px 20px" }}>
//             <TextEditor templates={testTemplates} value={instructionsHtml} setValue={setInstructionsHtml} />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default DppScheduling;

import React, { useRef, useState, useEffect } from "react";
import "./DppScheduling.css";
import DropDown from "../../../Components/Shared/Dropdown/Dropdown";
import InputComponent from "../TestScheduling/Input-testscheduling";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import introgativeImgBlue from "../../../Assets/Images/CommanImages/IntrogativeBlue.png";
import TextEditor from "./TextEditor";
import InputComponent2 from "./InputComponent";
import ErrorImg from "../../../Assets/Images/CommanImages/Error.png";
import SucessImg from "../../../Assets/Images/CommanImages/success.png";
import MultiSelectSearchDropdown from "./MultiDropdownClassic";
import { useLocation } from "react-router-dom";
import { POST } from "../../../Api/HttpsMethods";
import { GET } from "../../../Api/HttpsMethods";
import EndPoints from "../../../Api/EndPoints";
import { useNavigate } from "react-router-dom";
import Colors from "../../../Constants/Colors";
import FormInputs from "../../../Components/Shared/FormInputs/FormInputs";

const DppScheduling = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
}) => {
  const location = useLocation();
  const dppData = location.state;
  const navigate = useNavigate();

  useEffect(() => {
    if (dataClient) {
      const userName =
        dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
      const clientBranchId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
      const clientId =
        dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
      sessionStorage.setItem("user_name", userName);
      sessionStorage.setItem("clientBranchId", clientBranchId);
      sessionStorage.setItem("clientId", clientId);
    }
  }, [dataClient]);

  const userName =
    dataClient?.client_schema_name?.[6]?.[0]?.user_name ||
    sessionStorage.getItem("user_name") ||
    "";
  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
    sessionStorage.getItem("clientBranchId") ||
    null;
  const clientId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_id ||
    sessionStorage.getItem("clientId") ||
    null;
  const accessToken = localStorage.getItem("other");

  const [selectedQuestionPaperSubjects, setSelectedQuestionPaperSubjects] =
    useState("");
  const [selectedChapterId, setSelectedChapterId] = useState([]);
  const [selectedChapterName, setSelectedChapterName] = useState("");
  const [selectedTopicId, setSelectedTopicId] = useState([]);
  const [selectedTopicName, setSelectedTopicName] = useState("");
  const [instructionsHtml, setInstructionsHtml] = useState("");
  const [selectedQuestionPaperId, setSelectedQuestionPaperId] = useState("");
  const [selectedQuestionPaperName, setSelectedQuestionPaperName] =
    useState("");
  const [
    selectedQuestionPaperDescription,
    setSelectedQuestionPaperDescription,
  ] = useState("");
  const [selectedQuestionPaperCreatedBy, setSelectedQuestionPaperCreatedBy] =
    useState("");
  const [testTemplates, setTestTemplates] = useState([]);
  const [testStartDate, setTestStartDate] = useState(null);
  const [testEndDate, setTestEndDate] = useState(null);
  const [courses, setCourses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [classes, setClasses] = useState([]);
  const [topics, setTopics] = useState([]);
  const [questionPapers, setQuestionPapers] = useState([]);
  const [dppName, setDppName] = useState("");
  const [DppDescription, setDppDescription] = useState("");
  const [CordinatorName, setCordinatorName] = useState("");
  const [batches, setBatches] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState([]);
  const [selectedCourseName, setSelectedCourseName] = useState("");
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [selectedBatchName, setSelectedBatchName] = useState("");
  const [selectedSubjectId, setSelectedSubjectId] = useState("");
  const [selectedSubjectName, setSelectedSubjectName] = useState("");
  const [selectedClassId, setSelectedClassId] = useState("");
  const [selectedClassName, setSelectedClassName] = useState("");
  const [selectedStudentGroup, setSelectedStudentGroup] = useState([]);
  const [studentGroupsOptions, setStudentGroupsOptions] = useState([]);
  const [allStudentGroups, setAllStudentGroups] = useState([]);
  const [studentGroupsError, setStudentGroupsError] = useState(null);
  const [serverCurrentTime, setServerCurrentTime] = useState(null);
  const [isOpenSubject, setIsOpenSubject] = useState(true);
  const [fillInTheBlanksSuggestions, setFillInTheBlanksSuggestions] = useState("");

  // ── Fetch server current time ─────────────────────────────────────────────
  useEffect(() => {
    const fetchServerTime = async () => {
      try {
        const token = localStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-current-datetime/`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        if (data?.status === 200 && data?.data) {
          const { current_date, current_time } = data.data;
          setServerCurrentTime(`${current_date}T${current_time}`);
        }
      } catch (error) {
        console.error("Error fetching server time:", error);
        setServerCurrentTime(new Date().toISOString());
      }
    };
    fetchServerTime();
  }, []);

  // ── getCurrentDateTime: server time + 15 min buffer ──────────────────────
  const getCurrentDateTime = () => {
    const base = serverCurrentTime ? new Date(serverCurrentTime) : new Date();
    base.setMinutes(base.getMinutes() + 15);
    const year = base.getFullYear();
    const month = String(base.getMonth() + 1).padStart(2, "0");
    const day = String(base.getDate()).padStart(2, "0");
    const hours = String(base.getHours()).padStart(2, "0");
    const mins = String(base.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${mins}`;
  };

  // ── getMinEndDateTime: start + 24 hours ──────────────────────────────────
  const getMinEndDateTime = (startDateTime) => {
    if (!startDateTime) return getCurrentDateTime();
    const startDate = new Date(startDateTime);
    const minEndDate = new Date(startDate.getTime() + 24 * 60 * 60 * 1000);
    const year = minEndDate.getFullYear();
    const month = String(minEndDate.getMonth() + 1).padStart(2, "0");
    const day = String(minEndDate.getDate()).padStart(2, "0");
    const hours = String(minEndDate.getHours()).padStart(2, "0");
    const mins = String(minEndDate.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${mins}`;
  };

  useEffect(() => {
    if (!userName || !clientBranchId) return;
    const fetchTestTemplates = async () => {
      try {
        const token = localStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-dpp-instructions-template-list/?username=${userName}&branch_id=${clientBranchId}`,
          {
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        setTestTemplates(data);
      } catch (error) {
        console.error("Error fetching test templates:", error);
        if (setMessageBox) {
          setMessageBox(
            <div className="Container-messageBOX">
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>Error fetching test templates: {error.message}</span>
              </div>
            </div>
          );
          setIsMessageBoxVisible(true);
          setActiveImg(ErrorImg);
        }
      }
    };
    fetchTestTemplates();
  }, [userName, clientBranchId]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(`${FULL_API_BASE_URL}/get-courses/`, {
          headers: { accept: "application/json" },
        });
        const data = await response.json();
        setCourses(data);
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };
    fetchCourses();
  }, []);

  useEffect(() => {
    const fetchBatches = async () => {
      if (!selectedCourseId) return;
      const url = `${EndPoints.GetBatchByCourse}?course_id=${selectedCourseId}`;
      const data = await GET.noToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });
      if (Array.isArray(data?.[0])) {
        setBatches(
          selectedClassId
            ? data[0].filter((batch) => batch.class_id === selectedClassId)
            : data[0]
        );
      } else setBatches([]);
    };
    fetchBatches();
  }, [selectedCourseId, selectedClassId]);

  // useEffect(() => {
  //   const fetchSubjects = async () => {
  //     if (!selectedCourseId) return;
  //     const url = `${EndPoints.GetSubjectsByCourse}?course_id=${selectedCourseId}`;
  //     const data = await GET.noToken(url, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
  //     if (data) setSubjects(data);
  //   };
  //   fetchSubjects();
  // }, [selectedCourseId]);

  useEffect(() => {
    const fetchSubjects = async () => {
      if (!selectedCourseId) { setSubjects([]); return; }
      const url = `${EndPoints.GetSubjectsByCourse}?course_id=${selectedCourseId}`;
      const data = await GET.noToken(url, { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg });
      if (Array.isArray(data)) setSubjects(data);
      else setSubjects([]);
    };
    fetchSubjects();
  }, [selectedCourseId]);

  useEffect(() => {
    const fetchChapters = async () => {
      if (!selectedSubjectId) return;
      const url = `${EndPoints.GetChaptersBySubject}?subject_id=${selectedSubjectId}`;
      const data = await GET.noToken(url, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });
      if (data) setChapters(data);
    };
    fetchChapters();
  }, [selectedSubjectId]);

  useEffect(() => {
    const fetchTopics = async () => {
      if (
        !selectedChapterId ||
        !Array.isArray(selectedChapterId) ||
        selectedChapterId.length === 0
      ) {
        setTopics([]);
        return;
      }
      const data = await POST.withToken(
        EndPoints.TopicsByChapterList,
        selectedChapterId,
        { setMessageBox, setIsMessageBoxVisible, setActiveImg, ErrorImg }
      );
      if (data && data.status_code === 200 && Array.isArray(data.data))
        setTopics(data.data);
      else setTopics([]);
    };
    fetchTopics();
  }, [selectedChapterId]);

  useEffect(() => {
    const fetchClasses = async () => {
      const data = await GET.noToken(EndPoints.GetClasses, {
        setMessageBox,
        setIsMessageBoxVisible,
        setActiveImg,
        ErrorImg,
      });
      if (data) setClasses(data);
    };
    fetchClasses();
  }, []);

  useEffect(() => {
    const fetchQuestionPapers = async () => {
      if (!clientBranchId || !selectedClassId || !selectedSubjectId) return;
      let baseUrl = `${EndPoints.DPP_QUESTION_PAPER_V2}?branch_id=${clientBranchId}&class_id=${selectedClassId}&subject_id=${selectedSubjectId}`;
      // if (selectedBatchId) baseUrl += `&batch_id=${selectedBatchId}`;
      if (Array.isArray(selectedBatchId) && selectedBatchId.length > 0) {
        selectedBatchId.forEach((id) => { baseUrl += `&batch_id=${id}`; });
      }
      if (selectedStudentGroup && selectedStudentGroup.length > 0) {
        (Array.isArray(selectedStudentGroup)
          ? selectedStudentGroup
          : [selectedStudentGroup]
        ).forEach((id) => {
          baseUrl += `&student_group_ids=${id}`;
        });
      }
      if (Array.isArray(selectedChapterId) && selectedChapterId.length > 0)
        selectedChapterId.forEach((id) => {
          baseUrl += `&chapter_id=${id}`;
        });
      if (Array.isArray(selectedTopicId) && selectedTopicId.length > 0)
        selectedTopicId.forEach((id) => {
          baseUrl += `&topic_id=${id}`;
        });
      try {
        const response = await fetch(baseUrl, {
          method: "GET",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const result = await response.json();
        if (result?.status === 200) setQuestionPapers(result.data);
        else setQuestionPapers([]);
      } catch (error) {
        console.error("Error fetching question papers:", error);
        setQuestionPapers([]);
      }
    };
    fetchQuestionPapers();
  }, [selectedChapterId, selectedTopicId, selectedSubjectId, selectedClassId, clientBranchId, JSON.stringify(selectedBatchId), selectedStudentGroup]);

  // ── handleSave — all date validation happens here ─────────────────────────
  const handleSave = async () => {
    // ── Validate start date ───────────────────────────────────────────────────
    const minAllowed = getCurrentDateTime(); // server time + 15 min
    if (!testStartDate) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select a DPP Window Start date.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }
    if (testStartDate < minAllowed) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              DPP window start must be at least 15 minutes from current time.
              Please correct the start time before saving.
            </span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }

    // ── Validate end date ─────────────────────────────────────────────────────
    if (!testEndDate) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select a DPP Window End date.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }
    if (testEndDate <= testStartDate) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>DPP window end must be after the DPP window start.</span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }
    if (testEndDate < getMinEndDateTime(testStartDate)) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>
              DPP window end must be at least 24 hours after the start time.
            </span>
          </div>
        </div>
      );
      setActiveImg(ErrorImg);
      setIsMessageBoxVisible(true);
      return;
    }

    // ── Validate other required fields ────────────────────────────────────────
    if (!dppName.trim()) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please enter a DPP Name.</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      return;
    }

    if (fillInTheBlanksSuggestions === "" || fillInTheBlanksSuggestions === null || fillInTheBlanksSuggestions === undefined) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Please select Fill in the Blanks Suggestions option.</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
      return;
    }

    const studentGroupIds = Array.isArray(selectedStudentGroup)
      ? selectedStudentGroup
      : selectedStudentGroup
      ? [selectedStudentGroup]
      : [];

    const body = {
      request: {
        ques_paper_id: selectedQuestionPaperId,
        dpp_name: dppName,
        dpp_desc: DppDescription,
        // batch_id: selectedBatchId || 0,
        batch_id_list: Array.isArray(selectedBatchId) && selectedBatchId.length > 0 ? selectedBatchId : [],
        student_group_ids: studentGroupIds,
        dpp_window_start: testStartDate,
        dpp_window_end: testEndDate,
        client_id: clientId,
        client_branch_id: clientBranchId,
        created_by: userName,
        instructions_html: instructionsHtml,
        subject_id: selectedSubjectId || 0,
        chapter_names: selectedChapterName,
        topic_names: selectedTopicName,
        fill_in_the_blanks_suggestions: fillInTheBlanksSuggestions,
      },
      payload: {
        user_name: userName,
        client_branch_id: clientBranchId ? Number(clientBranchId) : 0,
        screen_event_id: 72,
        screen_id: 77,
        student_id: null,
        // batch_id: selectedBatchId ? [selectedBatchId] : null,
        batch_id: Array.isArray(selectedBatchId) && selectedBatchId.length > 0 ? selectedBatchId : null,
        subject_id: selectedSubjectId ? [selectedSubjectId] : null,
        class_id: selectedClassId ? [selectedClassId] : null,
        course_id: selectedCourseId ? [selectedCourseId] : null,
        session_id: null,
        student_group_id: studentGroupIds.length ? studentGroupIds : null,
      },
    };

    // try {
    //   const token = localStorage.getItem("other");
    //   const response = await fetch(EndPoints.CREATE_DPP_SCHEDULE_NOTIFICATION, {
    //     method: "POST",
    //     headers: { Accept: "application/json", "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    //     body: JSON.stringify(body),
    //   });
      try {
        const token = localStorage.getItem("other");
        const response = await fetch(
          `${FULL_API_BASE_URL}/create-dpp-schedule-notification/`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(body),
          }
        );
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      if (data && data.status === 200) {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                {data.message || "DPP schedule created successfully!"}
              </span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(SucessImg);
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      } else {
        setMessageBox(
          <div className="Container-messageBOX">
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>
                {"Failed to create DPP Schedule: " +
                  (data?.message || data?.detail || "Unknown error")}
              </span>
            </div>
          </div>
        );
        setIsMessageBoxVisible(true);
        setActiveImg(ErrorImg);
      }
    } catch (error) {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span>Error creating DPP schedule: {error.message}</span>
          </div>
        </div>
      );
      setIsMessageBoxVisible(true);
      setActiveImg(ErrorImg);
    }
  };

  useEffect(() => {
    if (!selectedQuestionPaperId) {
      setSelectedQuestionPaperSubjects("");
      return;
    }
    const qp = questionPapers.find(
      (q) => q.ques_paper_id === selectedQuestionPaperId
    );
    setSelectedQuestionPaperSubjects(qp?.subject_name || "");
  }, [selectedQuestionPaperId, questionPapers]);

  // Cascading clear logic
  useEffect(() => { setSelectedBatchId([]); setSelectedBatchName(""); }, [selectedClassId]);
  // useEffect(() => { setSelectedSubjectId(""); setSelectedSubjectName(""); }, [selectedBatchId]);
  useEffect(() => { setSelectedChapterId([]); setSelectedChapterName(""); }, [selectedSubjectId]);
  useEffect(() => { setSelectedTopicId([]); setSelectedTopicName(""); }, [selectedChapterId]);
  // useEffect(() => { setSelectedQuestionPaperId(""); setSelectedQuestionPaperName(""); }, [selectedCourseId, selectedClassId, selectedBatchId, selectedSubjectId, selectedChapterId, selectedTopicId]);
 useEffect(() => { setSelectedQuestionPaperId(""); setSelectedQuestionPaperName(""); }, [selectedCourseId, selectedClassId, JSON.stringify(selectedBatchId), selectedSubjectId, selectedChapterId, selectedTopicId]);
  useEffect(() => {
    if (!selectedQuestionPaperId) {
      setSelectedQuestionPaperDescription("");
      setSelectedQuestionPaperCreatedBy("");
      setSelectedQuestionPaperSubjects("");
      setCordinatorName("");
    }
  }, [selectedQuestionPaperId]);

  // Course/Class change also resets the manually-entered fields below them
  useEffect(() => {
    setDppName("");
    setDppDescription("");
    setInstructionsHtml("");
    setTestStartDate(null);
    setTestEndDate(null);
  }, [selectedCourseId, selectedClassId]);

  useEffect(() => {
    const fetchStudentGroups = async () => {
      if (!clientBranchId) return;
      try {
        setStudentGroupsError(null);
        const url = `${FULL_API_BASE_URL}/get-shared-student-groups?client_branch_id=${clientBranchId}`;
        const resp = await fetch(url, {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        });
        if (resp.status === 401 || resp.status === 403) {
          setStudentGroupsError("Not authenticated. Please login.");
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
          return;
        }
        const json = await resp.json();
        if (
          json &&
          (json.status === "200" || json.status === 200) &&
          Array.isArray(json.data)
        ) {
          const options = json.data.map((group) => ({
            id: group.student_group_id,
            label: group.student_group_name,
            session_id: group.session_id || "",
            course_id: group.course_id || "",
          }));
          setStudentGroupsOptions(options);
          setAllStudentGroups(options);
        } else {
          setStudentGroupsOptions([]);
          setAllStudentGroups([]);
        }
      } catch (err) {
        setStudentGroupsError(err.message || "Error loading student groups");
        setStudentGroupsOptions([]);
        setAllStudentGroups([]);
      }
    };
    fetchStudentGroups();
  }, [clientBranchId, accessToken]);

  useEffect(() => {
    setSelectedStudentGroup([]);
  }, [selectedCourseId]);

  const getFilteredStudentGroups = () => {
    if (!selectedCourseId) return studentGroupsOptions;
    return studentGroupsOptions.filter((g) => g.course_id === selectedCourseId);
  };

  const searchStudentGroups = (searchKey) => {
    let filtered = allStudentGroups;
    if (selectedCourseId)
      filtered = filtered.filter((g) => g.course_id === selectedCourseId);
    if (searchKey && searchKey.trim() !== "")
      filtered = filtered.filter((g) =>
        g.label.toLowerCase().includes(searchKey.toLowerCase())
      );
    setStudentGroupsOptions(filtered);
  };

  const toggleAccordionSubjects = () => {
    setIsOpenSubject(!isOpenSubject);
  };

  return (
    <div className="create-role-container dpp-scheduling-page">
      <div className="create-role-container-ques-paper-del">
        <span className="create-role-heading">DPP Scheduling</span>
        <div className="cr-header-btn-container">
          <button className="cr-cancel-btn" onClick={() => navigate(-1)}>
            CANCEL
          </button>
          <button className="cr-create-btn" onClick={handleSave}>
            SAVE
          </button>
        </div>
      </div>
      <div className="ques-paper-del">
        <div className="personal-header">
          <div className="header">
            <label>QUESTION PAPER DETAIL</label>
          </div>
        </div>
        <div className="accordion-content">
          <div className="select-assign-test-container-ques-pap-del">
            <div className="grid-container-ques-paper-del">
              <div>
                <DropDown
                  label="Select Course"
                  style={{ width: "100%" }}
                  setSelected={(selectedId) => {
                    setSelectedCourseId(selectedId);
                    setSelectedCourseName(selectedId.label);
                  }}
                  options={courses.map((course) => ({
                    label: course.course_name,
                    id: course.course_id,
                  }))}
                  isRequired={true}
                />
              </div>
              <div>
                <DropDown
                  key={`class-${selectedCourseId}`}
                  label="Select Class"
                  style={{ width: "100%" }}
                  value={selectedClassId}
                  setSelected={(selectedClassIdFromDD) => {
                    const classOption = Array.isArray(classes)
                      ? classes.find(
                          (cls) => cls.class_id === selectedClassIdFromDD
                        )
                      : undefined;
                    if (classOption) {
                      setSelectedClassId(classOption.class_id);
                      setSelectedClassName(classOption.class_name);
                    } else {
                      setSelectedClassId("");
                      setSelectedClassName("");
                    }
                  }}
                  options={classes.map((cls) => ({
                    label: cls.class_name,
                    id: cls.class_id,
                  }))}
                  isRequired={true}
                />
              </div>
              <div>
                {/* <DropDown
                  key={`batch-${selectedClassId}`} label="Batch Name" style={{ width: "100%" }} value={selectedBatchId}
                  setSelected={(selectedBatchIdFromDD) => {
                    const batchOption = Array.isArray(batches)
                      ? batches.find(
                          (batch) => batch.batch_id === selectedBatchIdFromDD
                        )
                      : undefined;
                    if (batchOption) {
                      setSelectedBatchId(batchOption.batch_id);
                      setSelectedBatchName(batchOption.batch_name);
                    } else {
                      setSelectedBatchId("");
                      setSelectedBatchName("");
                    }
                  }}
                  options={batches.map((batch) => ({
                    label: batch.batch_name,
                    id: batch.batch_id,
                  }))}
                  isRequired={false}
                /> */}
                <MultiSelectSearchDropdown
                  label="Batch Name" width="100%" selected={selectedBatchId}
                  setSelected={(selectedIds) => {
                    setSelectedBatchId(selectedIds);
                    if (Array.isArray(selectedIds) && selectedIds.length > 0) {
                      setSelectedBatchName(
                        batches.filter((b) => selectedIds.includes(b.batch_id)).map((b) => b.batch_name).join(", ")
                      );
                    } else {
                      setSelectedBatchName("");
                    }
                  }}
                  options={batches.map((batch) => ({ label: batch.batch_name, id: batch.batch_id }))}
                  isRequired={false} placeholder="Select Batch..." singleSelect={false}
                />
              </div>
              <div>
                <MultiSelectSearchDropdown
                  label="Student Group"
                  width="100%"
                  selected={selectedStudentGroup}
                  setSelected={setSelectedStudentGroup}
                  options={getFilteredStudentGroups().map((g) => ({
                    label: g.label,
                    id: g.id,
                  }))}
                  isRequired={false}
                  placeholder="Select Student Group..."
                  singleSelect={false}
                  onSearchInputChange={searchStudentGroups}
                />
                {studentGroupsError && (
                  <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                    {studentGroupsError}
                  </div>
                )}
              </div>
              <div>
                <DropDown
                  // key={`subject-${selectedBatchId}`} label="Select Subject" style={{ width: "100%" }} value={selectedSubjectId}
                  key={`subject-${selectedCourseId}`} label="Select Subject" style={{ width: "100%" }} value={selectedSubjectId}
                  setSelected={(selectedSubjectIdFromDD) => {
                    const subjectOption = Array.isArray(subjects)
                      ? subjects.find(
                          (subject) =>
                            subject.subject_id === selectedSubjectIdFromDD
                        )
                      : undefined;
                    if (subjectOption) {
                      setSelectedSubjectId(subjectOption.subject_id);
                      setSelectedSubjectName(subjectOption.subject_name);
                    } else {
                      setSelectedSubjectId("");
                      setSelectedSubjectName("");
                    }
                  }}
                  options={subjects.map((subject) => ({
                    label: subject.subject_name,
                    id: subject.subject_id,
                  }))}
                />
              </div>
              <div>
                <MultiSelectSearchDropdown
                  label="Select Chapter (Optional)"
                  width="100%"
                  selected={selectedChapterId}
                  setSelected={(selectedIds) => {
                    setSelectedChapterId(selectedIds);
                    if (Array.isArray(selectedIds) && selectedIds.length > 0)
                      setSelectedChapterName(
                        chapters
                          .filter((c) => selectedIds.includes(c.chapter_id))
                          .map((c) => c.chapter_name)
                          .join(", ")
                      );
                    else setSelectedChapterName("");
                  }}
                  options={chapters.map((chapter) => ({
                    label: chapter.chapter_name,
                    id: chapter.chapter_id,
                  }))}
                  isRequired={false}
                />
              </div>
              <div>
                <MultiSelectSearchDropdown
                  label="Select Topic (Optional)"
                  width="100%"
                  selected={selectedTopicId}
                  setSelected={(selectedIds) => {
                    setSelectedTopicId(selectedIds);
                    if (Array.isArray(selectedIds) && selectedIds.length > 0)
                      setSelectedTopicName(
                        (Array.isArray(topics)
                          ? topics.filter((t) =>
                              selectedIds.includes(t.topic_id)
                            )
                          : []
                        )
                          .map((t) => t.topic_name)
                          .join(", ")
                      );
                    else setSelectedTopicName("");
                  }}
                  options={
                    Array.isArray(topics)
                      ? topics.map((topic) => ({
                          label: topic.topic_name,
                          id: topic.topic_id,
                        }))
                      : []
                  }
                  isRequired={false}
                />
              </div>
              <div>
                <DropDown
                  key={`qp-${selectedCourseId}-${selectedClassId}-${selectedBatchId}-${selectedSubjectId}-${(
                    selectedChapterId || []
                  ).join(",")}-${(selectedTopicId || []).join(",")}`}
                  label="Question Paper Name"
                  style={{ width: "100%" }}
                  setSelected={(selectedQPId) => {
                    const qpOption = Array.isArray(questionPapers)
                      ? questionPapers.find(
                          (qp) => qp.ques_paper_id === selectedQPId
                        )
                      : undefined;
                    if (qpOption) {
                      setSelectedQuestionPaperId(qpOption.ques_paper_id);
                      setSelectedQuestionPaperName(qpOption.ques_paper_name);
                      setSelectedQuestionPaperDescription(qpOption.description);
                      setSelectedQuestionPaperCreatedBy(qpOption.created_by);
                      setSelectedQuestionPaperSubjects(
                        qpOption.subject_name || ""
                      );
                    } else {
                      setSelectedQuestionPaperId("");
                      setSelectedQuestionPaperName("");
                      setSelectedQuestionPaperDescription("");
                      setSelectedQuestionPaperCreatedBy("");
                      setSelectedQuestionPaperSubjects("");
                    }
                  }}
                  options={questionPapers.map((qp) => ({
                    label: qp.ques_paper_name,
                    id: qp.ques_paper_id,
                  }))}
                  isRequired={true}
                  minheight="250px"
                  Height="auto"
                  OverFlow="auto"
                />
              </div>
              <div>
                <InputComponent
                  label="Question Paper Subjects"
                  style={{ width: "100%" }}
                  value={selectedQuestionPaperSubjects}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <InputComponent
                  label="Question Paper Created By"
                  style={{ width: "100%" }}
                  value={selectedQuestionPaperCreatedBy}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div style={{ gridColumn: "2 / 4" }}>
                <InputComponent
                  label="Question Paper Description"
                  style={{ width: "100%" }}
                  value={selectedQuestionPaperDescription}
                  isRequired={false}
                  disable={true}
                />
              </div>
              <div>
                <FormInputs
                  label="DPP Name"
                  value={dppName}
                  onChange={(e) => setDppName(e.target.value)}
                  placeholder="Enter DPP name"
                  style={{ width: "100%" }}
                  required
                />
              </div>
              <div>
                <FormInputs
                  label="Description"
                  value={DppDescription}
                  onChange={(e) => setDppDescription(e.target.value)}
                  placeholder="Enter Description"
                  style={{ width: "100%" }}
                  required
                />
              </div>
              <div>
                <DropDown
                    label="Fill in the blanks - Suggestions"
                    style={{ width: "100%" }}
                    setSelected={(selected) => {
                      setFillInTheBlanksSuggestions(selected); 
                    }}
                    options={[
                      { label: "Enable", id: true },
                      { label: "Disable", id: false },
                    ]}
                    isRequired={true}
                  />
              </div>
              <div>
                <FormInputs
                  label="Batch Coordinator Name"
                  style={{ width: "100%" }}
                  value={CordinatorName}
                  isRequired={false}
                  disabled={true}
                />
              </div>

              {/* ── DPP Window Start — free input, all validation on SAVE ─── */}
              <div>
                <FormInputs
                  label="DPP Window Start"
                  style={{ width: "100%" }}
                  value={testStartDate || ""}
                  isRequired={false}
                  disable={false}
                  type="datetime-local"
                  min={getCurrentDateTime()}
                  onChange={(e) => {
                    const newStartDate = e.target.value;
                    setTestStartDate(newStartDate);
                    // Auto-fill end to start + 24h (UX convenience, not validation)
                    if (newStartDate) {
                      setTestEndDate(getMinEndDateTime(newStartDate));
                    }
                  }}
                  required
                />
              </div>

              {/* ── DPP Window End — free input, all validation on SAVE ───── */}
              <div>
                <FormInputs
                  label="DPP Window End"
                  style={{ width: "100%" }}
                  value={testEndDate || ""}
                  isRequired={false}
                  disable={false}
                  type="datetime-local"
                  min={
                    testStartDate
                      ? getMinEndDateTime(testStartDate)
                      : getCurrentDateTime()
                  }
                  onChange={(e) => {
                    setTestEndDate(e.target.value);
                  }}
                  required
                />
              </div>
            </div>
          </div>
          <div className="dpp-instructions-wrapper">
            <TextEditor
              templates={testTemplates}
              value={instructionsHtml}
              setValue={setInstructionsHtml}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DppScheduling;
